import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import { Card, CardHeader } from 'reactstrap';
import { H4 } from '../../../../AbstractElements';
import { UsersTableHeader, UsersTableTitle } from '../../../../Constant';
import CustomizerContext from '../../../../_helper/Customizer';
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import 'datatables.net-bs5';
import ManageTransactions from "../../../../api/ManageTransactions";
import ManageUsers from "../../../../api/ManageUsers";

const UserTable = ({ users, reloadAction }) => {
  const { layoutURL } = useContext(CustomizerContext);
  const tableRef = useRef(null);
  const [loadingUserId, setLoadingUserId] = useState(null);

  useEffect(() => {
    const table = $(tableRef.current).DataTable({
      language: {
        processing:     "Traitement en cours...",
        search:         "Rechercher&nbsp;:",
        lengthMenu:     "Afficher _MENU_ éléments",
        info:           "Affichage de l'élément _START_ à _END_ sur _TOTAL_ éléments",
        infoEmpty:      "Affichage de l'élément 0 à 0 sur 0 élément",
        infoFiltered:   "(filtré de _MAX_ éléments au total)",
        infoPostFix:    "",
        loadingRecords: "Chargement en cours...",
        zeroRecords:    "Aucun élément à afficher",
        emptyTable:     "Aucune donnée disponible dans le tableau",
        paginate: {
          first:      "Premier",
          previous:   "Précédent",
          next:       "Suivant",
          last:       "Dernier"
        },
        aria: {
          sortAscending:  ": activer pour trier la colonne par ordre croissant",
          sortDescending: ": activer pour trier la colonne par ordre décroissant"
        }
      }
    });
    return () => table.destroy();
  }, []);

  const handleAccountStateToggle = async (id, accountState) => {
    try {
      setLoadingUserId(id);
      const response = await ManageUsers.activateOrDesactivateUser({
        id,
        accountState
      });
      //const data = await response.json();
      console.log('API Response:', response);
      reloadAction();

    } catch (error) {
      console.error('Erreur lors du changement d’état du compte:', error);
    } finally {
      setLoadingUserId(null);
    }
  };

  useEffect(() => {
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      const table = $(tableRef.current).DataTable();
      table.clear();

      users.forEach((user) => {
        const isActive = user.account_state === 1;

        table.row.add([
          user.xbet_id ?? '-',
          user.email ?? 'Pas de mail',
          user.role,
          isActive ? 'Active' : 'Inactive',
          `
            <button 
              class='btn btn-sm ${isActive ? 'btn-danger' : 'btn-success'}' 
              data-userid='${user.id}' 
              data-action='${!isActive}'
              ${loadingUserId === user.id ? 'disabled' : ''}
            >
              <i class='fa fa-${isActive ? 'trash' : 'check'}'></i> 
              ${loadingUserId === user.id ? 'Chargement...' : (isActive ? 'Désactiver' : 'Activer')}
            </button>
          `
        ]);
      });

      table.draw();

      // Ajout des événements après rendu des lignes
      $(tableRef.current).off('click', 'button').on('click', 'button', function () {
        const id = parseInt($(this).data('userid'));
        const action = $(this).data('action') === true || $(this).data('action') === 'true';
        handleAccountStateToggle(id, action);
      });
    }
  }, [users, loadingUserId]);

  return (
      <Fragment>
        <Card>
          <CardHeader>
            <H4 attrH4={{ className: 'card-title mb-0' }}>Liste des utilisateurs</H4>
            <div className='card-options'>
              <a className='card-options-collapse' href='#javascript' data-toggle='card-collapse'>
                <i className='fe fe-chevron-up'></i>
              </a>
              <a className='card-options-remove' href='#javascript' data-toggle='card-remove'>
                <i className='fe fe-x'></i>
              </a>
            </div>
          </CardHeader>
          <div className='table-responsive edit-table'>
            <table
                ref={tableRef}
                className='display table table-striped table-vcenter text-nowrap'
                style={{ width: '100%' }}
            >
              <thead>
              <tr>
                {UsersTableHeader.map((header, i) => (
                    <th key={i}>{header}</th>
                ))}
              </tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>
        </Card>
      </Fragment>
  );
};

export default UserTable;
